import React, { useState } from 'react';
import './dataManagementUI.css';

const DataManagementUI = () => {
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [filteredDownloadProgress, setFilteredDownloadProgress] = useState(0);
  const [filteredUploadProgress, setFilteredUploadProgress] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Mock car data
  const carData = [
    {
      aucnet_car_model_id: 'AUC001',
      car_brand: 'Toyota',
      car_model: 'Camry',
      car_year: 2022,
      car_price: '$25,000',
      car_location: 'Tokyo',
    },
    {
      aucnet_car_model_id: 'AUC002',
      car_brand: 'Honda',
      car_model: 'Civic',
      car_year: 2021,
      car_price: '$22,500',
      car_location: 'Osaka',
    },
    {
      aucnet_car_model_id: 'AUC003',
      car_brand: 'Nissan',
      car_model: 'Skyline',
      car_year: 2023,
      car_price: '$35,000',
      car_location: 'Yokohama',
    },
    {
      aucnet_car_model_id: 'AUC004',
      car_brand: 'Mazda',
      car_model: 'CX-5',
      car_year: 2022,
      car_price: '$28,000',
      car_location: 'Hiroshima',
    },
    {
      aucnet_car_model_id: 'AUC005',
      car_brand: 'Subaru',
      car_model: 'Outback',
      car_year: 2023,
      car_price: '$30,500',
      car_location: 'Gunma',
    },
    {
      aucnet_car_model_id: 'AUC006',
      car_brand: 'Mitsubishi',
      car_model: 'Outlander',
      car_year: 2022,
      car_price: '$27,800',
      car_location: 'Kyoto',
    }
  ];

  const handleDownload = (setProgress) => {
    setProgress(0);
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 10;
      });
    }, 100);
  };

  const handleUpload = (setProgress) => {
    setProgress(0);
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 8;
      });
    }, 100);
  };

  const totalPages = Math.ceil(carData.length / itemsPerPage);
  const currentData = carData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="data-management-container">
      <div className="data-management-header">
        <h1>AUCNET Data Management</h1>
        <p>Manage and publish your vehicle data efficiently</p>
      </div>

      <div className="data-management-grid">
        {/* Download Raw Data */}
        <div className="data-card">
          <div className="card-glow"></div>
          <div className="card-header">
            <h3>Download Raw Data</h3>
            <span className="card-badge">AUCNET JSON</span>
          </div>
          <p>Download complete AUCNET JSON raw dataset</p>
          <button 
            className="action-btn download-btn"
            onClick={() => handleDownload(setDownloadProgress)}
          >
            <span className="btn-content">Download Raw Data</span>
            <span className="btn-glow"></span>
          </button>
          <div className="circular-progress">
            <div className="progress-track"></div>
            <div 
              className="progress-fill"
              style={{ transform: `rotate(${downloadProgress * 3.6}deg)` }}
            ></div>
            <div className="progress-center">
              <span className="progress-text">{downloadProgress}%</span>
            </div>
          </div>
        </div>

        {/* Upload Raw Data */}
        <div className="data-card">
          <div className="card-glow"></div>
          <div className="card-header">
            <h3>Upload Raw Data</h3>
            <span className="card-badge">AUCNET JSON</span>
          </div>
          <p>Upload new AUCNET JSON raw dataset</p>
          <button 
            className="action-btn upload-btn"
            onClick={() => handleUpload(setUploadProgress)}
          >
            <span className="btn-content">Upload Raw Data</span>
            <span className="btn-glow"></span>
          </button>
          <div className="circular-progress">
            <div className="progress-track"></div>
            <div 
              className="progress-fill"
              style={{ transform: `rotate(${uploadProgress * 3.6}deg)` }}
            ></div>
            <div className="progress-center">
              <span className="progress-text">{uploadProgress}%</span>
            </div>
          </div>
        </div>

        {/* Download Filtered Data */}
        <div className="data-card">
          <div className="card-glow"></div>
          <div className="card-header">
            <h3>Download Filtered Data</h3>
            <span className="card-badge">Edited</span>
          </div>
          <p>Download filtered and edited dataset</p>
          <button 
            className="action-btn download-btn"
            onClick={() => handleDownload(setFilteredDownloadProgress)}
          >
            <span className="btn-content">Download Filtered Data</span>
            <span className="btn-glow"></span>
          </button>
          <div className="circular-progress">
            <div className="progress-track"></div>
            <div 
              className="progress-fill"
              style={{ transform: `rotate(${filteredDownloadProgress * 3.6}deg)` }}
            ></div>
            <div className="progress-center">
              <span className="progress-text">{filteredDownloadProgress}%</span>
            </div>
          </div>
        </div>

        {/* Upload Filtered Data */}
        <div className="data-card">
          <div className="card-glow"></div>
          <div className="card-header">
            <h3>Upload Filtered Data</h3>
            <span className="card-badge">Edited</span>
          </div>
          <p>Upload edited AUCNET JSON dataset</p>
          <button 
            className="action-btn upload-btn"
            onClick={() => handleUpload(setFilteredUploadProgress)}
          >
            <span className="btn-content">Upload Filtered Data</span>
            <span className="btn-glow"></span>
          </button>
          <div className="circular-progress">
            <div className="progress-track"></div>
            <div 
              className="progress-fill"
              style={{ transform: `rotate(${filteredUploadProgress * 3.6}deg)` }}
            ></div>
            <div className="progress-center">
              <span className="progress-text">{filteredUploadProgress}%</span>
            </div>
          </div>
        </div>
      </div>

      {/* Publishing Options */}
      <div className="publishing-section">
        <h2>Data Publishing Options</h2>
        
        <div className="publishing-cards">
          {/* Direct Upload Publish */}
          <div className="publish-card">
            <div className="card-glow"></div>
            <h3>Direct Upload Publish</h3>
            <p>Publish the last uploaded AUCNET JSON dataset</p>
            <button className="publish-btn primary">
              <span className="btn-content">Publish Now</span>
              <span className="btn-glow"></span>
            </button>
          </div>

          {/* Individual Model Publish */}
          <div className="publish-card">
            <div className="card-glow"></div>
            <h3>Individual Model Publish</h3>
            <p>Publish specific car models individually</p>
          </div>
        </div>

        {/* Car Models Table */}
        <div className="models-table-container">
          <div className="table-header">
            <h4>Car Models</h4>
            <div className="pagination-controls">
              <button 
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="pagination-btn"
              >
                ←
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button 
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="pagination-btn"
              >
                →
              </button>
            </div>
          </div>

          <div className="table-scroll">
            <table className="models-table">
              <thead>
                <tr>
                  <th>Model ID</th>
                  <th>Brand</th>
                  <th>Model</th>
                  <th>Year</th>
                  <th>Price</th>
                  <th>Location</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((car, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                    <td>{car.aucnet_car_model_id}</td>
                    <td>{car.car_brand}</td>
                    <td>{car.car_model}</td>
                    <td>{car.car_year}</td>
                    <td>{car.car_price}</td>
                    <td>{car.car_location}</td>
                    <td>
                      <button className="publish-btn secondary">
                        <span className="btn-content">Publish</span>
                        <span className="btn-glow"></span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataManagementUI;